<template>
  <p-list v-if="$hasPermission('workflows.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import List from '../components/workflows/List.vue';

export default {
  components: {
    'p-list': List,
    'p-not-found': NotFound
  }
};
</script>
